import { createSelector } from "@ngrx/store";
import { IContractEsState } from "@edp-store/state/ES/contract-es.state";
import { IAppEsState } from "@edp-store/state/ES/app-es.state";
import moment from "moment";
import { ContractStatusEsEnum } from "@edp-enums/ES/contract-status-es-enum";

const contractEsSelector = (state: IAppEsState) => state.contractsEs;

export const getContractsEs = createSelector(contractEsSelector, (state: IContractEsState) => state.contractsEs);

export const getContractEs = createSelector(contractEsSelector, (state: IContractEsState) => state.selectedContractEs.data);

export const getContractEsAPIError = createSelector(contractEsSelector, (state: IContractEsState) => state.selectedContractEs.lastAPIError);

// export const isSingleContract = createSelector(
//     contractEsSelector,
//     (state: IContractEsState) => state.isSingleContract
// );

// export const getUrlToRedirect = createSelector(
//     contractEsSelector,
//     (state: IContractEsState) => state.urlToRedirect
// );
